import { loginAsUser } from '../useCases/login-as-user.use-case';

export const reloadAfterLoginAsUserFullfilled = {
  actionCreator: loginAsUser.fulfilled,
  effect: async () => {
    // effect: async (action, { getState, dispatch }) => {
    setTimeout(() => {
      // location.reload();
    }, 500);
  },
};

export default reloadAfterLoginAsUserFullfilled;
